import { render, staticRenderFns } from "./SparklyBackground.vue?vue&type=template&id=35f44e76"
import script from "./SparklyBackground.vue?vue&type=script&lang=js"
export * from "./SparklyBackground.vue?vue&type=script&lang=js"
import style0 from "./SparklyBackground.vue?vue&type=style&index=0&id=35f44e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports